export default __webpack_public_path__ + "static/media/cesgs-logo-only.735bbdcf.png";